import InstagramSection from "./InstagramSection";

export const components = {
  instagram_section: InstagramSection
}